import { request } from '@/request/request';
import { parameterChange } from '@/utils/utils';

export default {
    // 报名列表
    enrollInfoList(data) {
        return request({
            url: '/enrollInfo/enrollInfoList',
            method: 'get',
        });
    },
    // 切换赛事
    switchEnroll(data) {
        return request({
            url: "/enrollInfo/switchEnroll",
            method: "post",
            data,
        });
    },
    // 学生参赛信息
    getMatchPlayers() {
        return request({
            url: '/stu-info/getMatchPlayers',
            method: 'get',
        });
    },
    // 粤见花开提交
    submitAnswerEnroll(data) {
        return request({
            url: "/structure-answer/submitAnswer",
            method: "post",
            data,
        });
    },
    // 粤见花开获取
    getAnswerEnroll() {
        return request({
            url: "/structure-answer/getAnswer",
            method: "get",
        });
    },
};
